import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import { Snackbar } from 'react-md';
import Logo from '../components/Logo';
import ContactForm from '../components/ContactForm';
import ReferencesSlider from '../components/ReferencesSlider';
import About from '../components/About';
import Footer from '../components/Footer';

import styles from './index.module.scss';

class IndexPage extends Component {
  state = { toasts: [] };

  encode = data => {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
  };

  handleContactFormSubmit = data => {
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: this.encode({ 'form-name': 'contact', ...data })
    })
    .then(() => {
      this.contactForm.reset();
      this.addToast('Thank you!');
    })
    .catch(error => {
      this.addToast(error);
    });
  };

  addToast = text => {
    this.setState({toasts: [...this.state.toasts, { text }]});
  };

  handleDismissToast = () => {
    const [, ...toasts] = this.state.toasts;
    this.setState({ toasts });
  };

  render() {
    const { data } = this.props;
    const { toasts } = this.state;
    return (
      <div>
        <Helmet>
          <link rel="canonical" href="https://boldit.hr" />
        </Helmet>
        <header className={styles.header}>
          <Logo />
          <h4 className="md-text-center">We make outstanding web and mobile solutions</h4>
        </header>
        <main className={styles.main}>
          <ReferencesSlider images={data} />
          <About siteMetadata={data.site.siteMetadata} />
          <ContactForm onSubmit={this.handleContactFormSubmit} ref={c => { this.contactForm = c; }} />
        </main>
        <footer className={styles.footer}><Footer /></footer>
        <Snackbar
          toasts={toasts}
          onDismiss={this.handleDismissToast}
        />
      </div>
    )
  }
};

IndexPage.propTypes = {
  data: PropTypes.object
};

export default IndexPage;

export const pageQuery = graphql`
  query IndexPageQuery {
    firstViewParentImage: imageSharp(id: { regex: "/first-view-parent.png/" }) {
      sizes(
        maxWidth: 768
        traceSVG: { background: "#fafafa", color: "#ececec", threshold: 230 }
      ) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    firstViewDistrictImage: imageSharp(id: { regex: "/first-view-district.png/" }) {
      sizes(
        maxWidth: 768
        traceSVG: { background: "#fafafa", color: "#ececec", threshold: 230 }
      ) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    firstBusConnectImage: imageSharp(id: { regex: "/first-bus-connect.png/" }) {
      sizes(
        maxWidth: 768
        traceSVG: { background: "#fafafa", color: "#ececec", threshold: 230 }
      ) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    scantherImage: imageSharp(id: { regex: "/scanther.png/" }) {
      sizes(
        maxWidth: 768
        traceSVG: { background: "#fafafa", color: "#ececec", threshold: 230 }
      ) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    smartHomeImage: imageSharp(id: { regex: "/smart-home.png/" }) {
      sizes(
        maxWidth: 768
        traceSVG: { background: "#fafafa", color: "#ececec", threshold: 230 }
      ) {
        ...GatsbyImageSharpSizes_tracedSVG
      }
    }
    site {
      siteMetadata {
        title
        description
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js